import React, { useEffect, useState, useCallback } from "react";
import { InputNumber, Slider } from "rsuite";
import { translate } from "../languages";

const HistogramChartOptions = ({ defaultValues = {}, onChange, screenSize }) => {
  const [binWidth, setBinWidth] = useState();
  const [gap, setGap] = useState();

  useEffect(() => {
    if (!binWidth) { setBinWidth(defaultValues.binWidth); }
    if (!gap){ setGap(defaultValues.gap); }
  }, [defaultValues, binWidth, gap]);

  const handleChange = useCallback((key, value) => {
    if ("binWidth" === key) {
      setBinWidth(value);
      onChange(key, { binWidth: value, gap });
    } else if ("gap" === key) {
      setGap(value);
    onChange(key, { binWidth, gap: value });
    }
  }, [onChange, binWidth, gap]);

  useEffect(() => {
    if (binWidth && binWidth !== defaultValues?.binWidth) { handleChange("binWidth", binWidth); }
    else if (gap && gap !== defaultValues?.gap) { handleChange("gap", gap); }
  }, [binWidth, gap, defaultValues, handleChange]);

  return (
    <div style={{ padding: "1rem", backgroundColor: "#f8f8f8", borderRadius: "8px", marginTop: "1rem" }}>
      <h5>{translate("Histogram Options")}</h5>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "2rem", alignItems: "center" }}>
        <div>
          <label>{translate("Bin width")}:</label><br />
          <InputNumber
            value={binWidth}
            min={0}
            step={1}
            onChange={(val) => { handleChange("binWidth", val || 0); }}
            postfix=" units"
            style={{ width: 120 }}
          />
        </div>
        <div>
          <label>{translate("Gap between bars")}:</label><br />
          <Slider
            value={gap}
            onChange={(val) => { handleChange("gap", val); }}
            step={0.01}
            min={0}
            max={1}
            style={{ width: screenSize < 500 ? "100%" : 200 }}
          />
        </div>
      </div>
    </div>
  );
};

export default HistogramChartOptions;
